<template>
  <div>
    <MessageIcons></MessageIcons>
    <br />
    <div class="columns is-desktop is-multiline">
      <div class="column is-3" v-for="(list, index) in listBeds" :key="index">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">N° Cama {{ list.n_cama }}</p>
          </header>
          <div class="card-content">
            <b-loading
              :is-full-page="false"
              v-model="isLoading"
              :can-cancel="true"
            ></b-loading>
            <div class="columns is-mobile">
              <div class="column is-4">
                <b-icon
                  icon="bed"
                  size="is-large"
                  type="is-success"
                  v-if="list.state == 'HABILITADA'"
                >
                </b-icon>
                <b-icon
                  icon="bed"
                  size="is-large"
                  type="is-danger"
                  v-else-if="list.state == 'BLOQUEADA'"
                >
                </b-icon>
              </div>
              <div class="column is-2">
                <span>
                  <b-icon
                    icon="user"
                    size="is-large"
                    :type="list.patient_id && list.state == 'HABILITADA' ? 'is-dark' : ''"
                    style="color: #dededef7"
                  >
                  </b-icon>
                </span>
              </div>
              <div class="column is-2">
                <b-icon
                  icon="virus"
                  size="is-large"
                  :type="list.covid19 == 'positivo' ? 'is-dark' : ''"
                  style="color: #dededef7"
                >
                </b-icon>
              </div>
              <div class="column is-2">
                <b-icon
                  icon="fan"
                  size="is-large"
                  :type="list.ventilator_used == 'si' ? 'is-dark' : ''"
                  style="color: #dededef7"
                >
                </b-icon>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item">
              <button-edit-bed :bed="list"></button-edit-bed>
            </a>
            <a
              class="card-footer-item"
              v-if="list.state == 'HABILITADA' && list.patient_id == null"
            >
              <button-assign-patient :bed="list"></button-assign-patient>
            </a>
            <a class="card-footer-item" v-if="list.patient_id !== null">
              <button-unassign-patient :bed="list"></button-unassign-patient>
            </a>
            <a class="card-footer-item" v-if="list.patient_id==null">
              <button-change-state-bed :bed="list"></button-change-state-bed>
            </a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonAssignPatient from "./ButtonAssignPatient.vue";
import MessageIcons from "./MessageIcons";
import { eventBus } from "../../main";
import ButtonChangeStateBed from "./ButtonChangeStateBed.vue";
import ButtonUnassignPatient from "./ButtonUnassignPatient.vue";
import ButtonEditBed from "./ButtonEditBed.vue";
// import ModalShowPatient from "./ModalShowPatient";

export default {
  props: ["listBeds"],
  components: {
    MessageIcons,
    ButtonAssignPatient,
    ButtonChangeStateBed,
    ButtonUnassignPatient,
    ButtonEditBed,    
  },
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    eventBus.$on("rechargeBedImage", (event) => {
      this.isLoading = event == true ? true : false;
    });
  },
  methods:{
    // openModalDataPatient(bed) {      
    //   if(bed.patient_id){
    //     this.$buefy.modal.open({
    //       parent: this,
    //       component: ModalShowPatient,
    //       props: {
    //         bed: bed,
    //       },
    //       hasModalCard: true,
    //       trapFocus: true,
    //     });
    //   }      
    // },
  }
};
</script>